import React, { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import ConfirmationModal from "../../shared/ConfirmationModal";
import NewconfirmationModal from "../../shared/NewconfirmationModal";
import AllFailureModal from "../../shared/AllFailureModal";

interface ContactFormValues {
  name: string;
  email: string;
  mobile: string;
  address: string;
  subject: string;
  message: string;
  isactive: string;
  userid: string;
}

const ContactAdd = () => {
  const initialValues: ContactFormValues = {
    name: "",
    email: "",
    mobile: "",
    address: "",
    subject: "",
    message: "",
    isactive: "",
    userid: "",
  };
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalmessage, setShowModalmessage] = useState("");
  const [newContact, setNewContact] = useState<ContactFormValues | null>(null);
  const [formValues, setFormValues] = useState<ContactFormValues>(initialValues);
  const navigate = useNavigate();

  const headers = {
    "x-access-token": localStorage.getItem("jwttoken") || "",
  };
  const addNewContact = async (values: ContactFormValues) => {
    try {
      const url = process.env.REACT_APP_API_URL + "contact/createcontact";
      const response = await axios.post(url, values, { headers });
      setSuccessMessage("Contact added successfully!");
      setShowSuccessModal(true);
      return { success: true };
    } catch (error) {
      console.error("Error adding contact:", error);
      setFailureMessage("Failed to add contact. Please try again.");
      setShowFailureModal(true);
      return { success: false };
    }
  };

  const handleSuccessModalClose = async() => {
    setShowModal(false);
    const result = await addNewContact(formValues);
    if (result.success) {
      setShowSuccessModal(true);
      setTimeout(() => {
        navigate("/contactlist");
      }, 3000);      
    } else {
      setShowFailureModal(true);
    }
  };
  const handleSubmitConfirmation = (values: ContactFormValues) => {
    setFormValues(values);
    setShowModalmessage("Are you sure you want to add this contact?");
    setShowModal(true);
  };
  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
              <Col md={8}>
                <Card className="shadow">
                  <Card.Header className="bg-info text-white text-center">
                    <h4>Contact Add</h4>
                  </Card.Header>
                  <Card.Body>
      <Formik
        initialValues={initialValues}
        onSubmit={async (values: ContactFormValues) => {
          handleSubmitConfirmation(values);
        }}
      >
        {({ values, errors, touched}) => (
          <Form>
            <Row className="mb-3">
              <Col md={6}>
              <label htmlFor="name" className="form-label">
                Name:
              </label>
              <Field name="name" type="text" className="form-control" placeholder="Enter Name" required/>
              </Col>
              <Col md={6}>
              <label htmlFor="userid" className="form-label">
                Userid:
              </label>
              <Field name="userid" type="text" className="form-control" placeholder="Enter Userid" required/>
              </Col>
            </Row>
            <Row className="mb-3">
             <Col md={6}>
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <Field name="email" type="email" className="form-control" placeholder="Enter Email" required/>
              </Col>
              <Col md={6}>
              <label htmlFor="mobile" className="form-label">
                Mobile
              </label>
              <Field name="mobile" type="text"  className={`form-control ${errors.mobile && touched.mobile ? "is-invalid" : ""}`}
                                        placeholder="Enter Mobile Number" required />
              <ErrorMessage name="mobile" component="div" className="text-danger" />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={12}>
              <label htmlFor="subject" className="form-label">
                Subject
              </label>
              <Field name="subject" type="text" className="form-control" placeholder="Enter Subject" required />
              </Col> 
            </Row>
            <Row className="mb-3">
              <Col md={12}>
              <label htmlFor="message" className="form-label">
                Message
              </label>
              <Field name="message" type="text"  as="textarea" className="form-control" placeholder="Enter Message" required />
            </Col>
            </Row>
              <Row className="mt-4">
                <Col className="text-center">
                <Button type="submit" variant="success">
                  Submit
                </Button>
                <Button
                  variant="danger" className="mx-2"
                  onClick={() => navigate("/ContactList")}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
      </Card.Body>
      </Card>
      </Col>
      </Row>
      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        modalMessage={showModalmessage}
        operationType="Confirm"
        confirmation={handleSuccessModalClose}
      />
    <NewconfirmationModal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} modalMessage={successMessage} operationType="OK" timeoutDuration={3000} />
         <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage} operationType="OK" timeoutDuration={5000} />
     </Container>    
  );
};

export default ContactAdd;
